const TeaserList = () => {
	const teasers = Array.from(document.querySelectorAll('.teaser-list .teaser'));

	teasers.forEach(teaser => {
		if (teaser.querySelector('a') && teaser.querySelector('.teaser-image')) {
			teaser.querySelector('.teaser-image').classList.add('teaser-image--clickable');
			teaser.querySelector('.teaser-image').addEventListener('click', () => {
				teaser.querySelector('a').click();
			})
		}
	});
};

export default TeaserList;
